import { boot, isChapterName } from '@dazn/bootstrap-lib';

const getChapterData = (searchParams: URLSearchParams) => {
    const data: Record<string, string | null> = {};
    searchParams.forEach((value, key) => (data[key] = value));

    delete data.chapterName;
    delete data.path;

    data.eventId ??= null;
    data.origin ??= 'web';

    return data;
};

export const getDeepLink = (window: Window): boot.config.DeepLink | null => {
    const { searchParams } = new URL(window.location.href);
    const hasSearchParams = searchParams.toString() !== '';

    const unguardedChapterName = searchParams.get('chapterName');
    const chapterPath = searchParams.get('path') ?? undefined;

    const chapterName = isChapterName(unguardedChapterName)
        ? unguardedChapterName
        : undefined;

    if (!chapterName && !chapterPath && !hasSearchParams) {
        return null;
    }

    return {
        chapterName,
        chapterPath,
        chapterData: hasSearchParams ? getChapterData(searchParams) : null,
    };
};
